export default {
	id: 'SIMPLE_WORKBOOK_BUNDLE_29_99',
	providers: {
		paltaMap: {
			USD: 'simple_workbook_bundle_29_99_usd',
			EUR: 'simple_workbook_bundle_29_99_eur',
			GBP: 'simple_workbook_bundle_29_99_gbp',
			AUD: 'simple_workbook_bundle_49_99_aud',
			CAD: 'simple_workbook_bundle_49_99_cad',
			DKK: 'simple_workbook_bundle_259_dkk',
			SEK: 'simple_workbook_bundle_399_sek',
			NOK: 'simple_workbook_bundle_399_nok',
			BRL: 'simple_workbook_bundle_199_99_brl',
			MXN: 'simple_workbook_bundle_499_mxn',
			TRY: 'simple_workbook_bundle_999_try',
			ARS: 'simple_workbook_bundle_39990_ars',
			COP: 'simple_workbook_bundle_119990_cop',
			CLP: 'simple_workbook_bundle_29990_clp',
		},
		primer: 'prd_gOsYvMStEsiT',
	},
	otp: {
		priceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			AUD: 49.99,
			CAD: 49.99,
			DKK: 259,
			SEK: 399,
			NOK: 399,
			BRL: 199.99,
			MXN: 499,
			TRY: 999,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
}
